import { useContext } from "react";
import { RyeIcon } from "../rye/RyeIcon";
import { buildClasses } from "../utils/buildClasses";
import { TransactionColumn } from "./TransactionColumn";
import {
  TransactionsNavContext,
  SortOrders,
  defaultTransactionsNav,
} from "./TransactionsScreen";
import { DisableFilteringAndSortingContext } from "./TransactionsTable";

export function SortIcon({
  column,
}: {
  column: TransactionColumn;
}): JSX.Element | null {
  const [transactionsNav, setTransactionsNav] = useContext(
    TransactionsNavContext,
  );
  const filteringAndSortingDisabled = useContext(
    DisableFilteringAndSortingContext,
  );

  if (filteringAndSortingDisabled) {
    return null;
  }

  // Three-state cycle per column:
  //   inactive → this column descending
  //   descending → ascending
  //   ascending → reset to the default sort
  function handleSortClick() {
    setTransactionsNav((prevState) => {
      if (prevState.sortColumn !== column) {
        return {
          ...prevState,
          sortColumn: column,
          sortOrder: SortOrders.Descending,
        };
      }
      if (prevState.sortOrder === SortOrders.Descending) {
        return { ...prevState, sortOrder: SortOrders.Ascending };
      }
      return {
        ...prevState,
        sortColumn: defaultTransactionsNav.sortColumn,
        sortOrder: defaultTransactionsNav.sortOrder,
      };
    });
  }

  let sortIconName: "arrow_circle_down" | "arrow_circle_up" =
    "arrow_circle_down";
  if (transactionsNav.sortOrder === SortOrders.Ascending) {
    sortIconName = "arrow_circle_up";
  }

  let sortIconTooltip = "Sort descending";
  if (transactionsNav.sortColumn === column) {
    if (transactionsNav.sortOrder === SortOrders.Ascending) {
      sortIconTooltip = "Switch sort to descending";
    } else {
      sortIconTooltip = "Switch sort to ascending";
    }
  }

  return transactionsNav.sortColumn === column ? (
    <RyeIcon
      name={sortIconName}
      size={"sm"}
      fill={true}
      className={buildClasses("text-purple", "cursor-pointer", "select-none")}
      onClick={handleSortClick}
      tooltip={sortIconTooltip}
    ></RyeIcon>
  ) : (
    <RyeIcon
      name={"arrow_circle_down"}
      size={"sm"}
      fill={false}
      className={buildClasses(
        "text-on-surface-400",
        "cursor-pointer",
        "select-none",
        "invisible",
        "group-hover:visible",
      )}
      onClick={handleSortClick}
      tooltip={sortIconTooltip}
    ></RyeIcon>
  );
}
